//
// SimulatedAnnealingPlacementOptions.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/GTLModel";
import "./SimulatedAnnealingWeight";

var SimulatedAnnealingPlacementOptions = createModule("gtl::SimulatedAnnealingPlacementOptions", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        maxIterations: 4,
        seed: 4,
        weights: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default SimulatedAnnealingPlacementOptions;
